import { render, staticRenderFns } from "./InventoryLogsDetail.vue?vue&type=template&id=3206dd6e&"
import script from "./InventoryLogsDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryLogsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports